import styled from "styled-components";
import { Row } from "@viagogo/core/ui";

export const VerticalMarginRow = styled(Row)`
  margin-top: ${(props) => props.theme.spacing(8)};
  margin-bottom: ${(props) => props.theme.spacing(12)};
`;

export const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-top: ${(props) => props.theme.spacing(6)};
  background-color: ${(props) => props.theme.colors.backgroundPrimary};

  @media ${({ theme: { media } }) => media.phone} {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    box-shadow: 0px -2px 8px 1px rgba(0, 0, 0, 0.08);
  }
`;

export const MarginDivLarge = styled.div`
  margin: ${(props) => props.theme.spacing(4)} 0;
  @media ${({ theme: { media } }) => media.tablet} {
    margin: ${(props) => props.theme.spacing(8)} 0;
  }
  @media ${({ theme: { media } }) => media.desktop} {
    margin: ${(props) => props.theme.spacing(8)} 0;
  }
`;
